const setDeviceName = (context, token) => {
  context.commit("SET_DEVICE_NAME", token);
};

const setDeviceToken = (context, token) => {
  context.commit("SET_DEVICE_TOKEN", token);
};

const setAdvertisingToken = (context, token) => {
  context.commit("SET_ADVERTISING_TOKEN", token);
};

export default {
  setDeviceName,
  setDeviceToken,
  setAdvertisingToken,
};
